import React, { ReactNode, useState } from 'react';
import { ThemeProvider } from 'styled-components/macro';

import {
  covideoAutomotiveTheme,
  covideoTheme,
  app2vidTheme,
  proVideoNowTheme,
  kennectedTheme,
  vidisTheme,
} from './themes';
import { ThemeTypes, THEME_LABELS } from './types';
import { CovideoThemeProvider } from 'react-covideo-common';

const getCovideoTheme = (theme: keyof ThemeTypes) => {
  switch (theme) {
    case THEME_LABELS.AUTOMOTIVE:
      return 'automotive';
    case THEME_LABELS.COVIDEO:
      return 'covideo';
    case THEME_LABELS.KENNECTED:
      return 'kennected';
    case THEME_LABELS.PRO_VIDEO:
      return 'provideo';
    case THEME_LABELS.VID:
      return 'app2vid';
    default:
      return 'covideo';
  }
};

const themesMap: ThemeTypes = {
  [THEME_LABELS.AUTOMOTIVE]: covideoAutomotiveTheme,
  [THEME_LABELS.COVIDEO]: covideoTheme,
  [THEME_LABELS.VID]: app2vidTheme,
  [THEME_LABELS.PRO_VIDEO]: proVideoNowTheme,
  [THEME_LABELS.KENNECTED]: kennectedTheme,
  [THEME_LABELS.VIDIS]: vidisTheme,
} as const;

export const Theme = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState<keyof ThemeTypes>(THEME_LABELS.AUTOMOTIVE);
  const currentTheme = { ...(themesMap?.[theme] || themesMap.covideoTheme) };

  return (
    <CovideoThemeProvider themeName={getCovideoTheme(theme)}>
      <ThemeProvider theme={{ ...currentTheme, setTheme }}>
        {children}
      </ThemeProvider>
    </CovideoThemeProvider>
  );
};
